import 'bootstrap'
import camelCase from 'camelcase'
import global from './controllers/global'

import agencies from './controllers/agencies/agencies'
import store_ai_call_contracts from './controllers/store_ai_call_contracts'
import store_ai_call_contract_workflows from './controllers/store_ai_call_contract_workflows'
import store_insight_contracts from './controllers/store_insight_contracts'
import store_insight_contract_workflows from './controllers/store_insight_contract_workflows'
import store_platform_contracts from './controllers/store_platform_contracts'
import store_platform_contract_workflows from './controllers/store_platform_contract_workflows'
import store_platform_settings from './controllers/store_platform_settings'
import stores from './controllers/stores'
import store_examinations from './controllers/store_examinations'
import g2_globals from './controllers/g2_globals'
import sub_merchant_lists from './controllers/sub_merchant_lists'
import dentals from './controllers/dentals'
import dental_examinations from './controllers/dental_examinations'
import complaints from './controllers/complaints/complaints'
import complaint_alert_keywords from './controllers/complaint_alert_keywords/complaint_alert_keywords'
import parent_stores from './controllers/parent_stores/parent_stores'
import brands from './controllers/brands'
import merchant_output_lists from './controllers/merchant_output_lists'
import virtual_bank_accounts from './controllers/virtual_bank_accounts'
import change_requests from './controllers/change_requests'
import registrations from './controllers/registrations'

import ai_call_create from './controllers/operations/ai_call/create'
import line_connect from './controllers/operations/line/connect'

const functions = {
  agencies,
  stores,
  store_examinations,
  g2_globals,
  sub_merchant_lists,
  dentals,
  dental_examinations,
  complaints,
  complaint_alert_keywords,
  parent_stores,
  brands,
  merchant_output_lists,

  store_ai_call_contracts,
  store_ai_call_contract_workflows,
  store_insight_contracts,
  store_insight_contract_workflows,
  store_platform_contracts,
  store_platform_contract_workflows,
  store_platform_settings,
  virtual_bank_accounts,
  change_requests,

  registrations,

  // operations系
  ai_call_create,
  line_connect,
}

const controllerName = document.getElementsByName('controller-name')[0].content.split("-").slice(-1)[0]
const actionName = camelCase(document.getElementsByName('action-name')[0].content)

global()

if (functions[controllerName] && functions[controllerName]['common']) functions[controllerName]['common']()
if (functions[controllerName] && functions[controllerName][actionName]) {
  functions[controllerName][actionName]()
} else if (functions[controllerName]) {
  if (actionName === 'create') { if (functions[controllerName]['new']) functions[controllerName]['new']() }
  if (actionName === 'update') { if (functions[controllerName]['edit']) functions[controllerName]['edit']() }
}
